import { UserRole } from "@/constants/userRoles"
import { UserRecord } from "@/types/UserRecord"

export const isAdmin = (user: UserRecord) => [UserRole.CLIENT_ADMIN, UserRole.LMNC_ADMIN].includes(user.role)
